module.exports = __webpack_public_path__ + "dashboard/img/menu.a2a5444c64ab754df9676aa08703a126.svg";